import React, { useEffect, useState } from 'react';
import {
  MainButton,
  MainLink,
  Subtitle,
  TextRegular,
  Title,
} from '../../styles/GlobalStyledComponents';
import { UnknowErrorImage } from '../UnknownError/UnknownErrorStyledComponent';
import PostMessageService from '../../services/PostMessage';

import ErrorImg from '../../assets/images/error/unknow-error.svg';
import ViewModeService from '../../services/ViewMode';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';
import AnalyticsService from '../../services/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';
import { useLocation } from 'react-router-dom';

interface UnprocessableProps {
  loadingEvent: (data: boolean) => void;
}

const Unprocessable: React.FC<UnprocessableProps> = ({ loadingEvent }) => {
  const { creditProposalResult } = useCreditProposalResult();
  const { isPostDataMessages } = useMerchant();

  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);

  const location = useLocation();

  const handleReturn = () => {
    if (isApp && device === 'android') {
      window.location.href = 'peppermerchants://home';
    } else {
      PostMessageService.closeCEX();
    }
  };

  useEffect(() => {
    const step_number = AnalyticsHelper.getStepLocation(location.pathname);
    AnalyticsService.sendEventKo(step_number);
    if (isPostDataMessages) {
      PostMessageService.FinancingFailed(
        creditProposalResult?.credit_proposal_id
      );
    }
  }, []);

  useEffect(() => {
    loadingEvent(false);
  }, [loadingEvent]);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  return (
    <>
      <Title id="unprocessable-title">Este enlace ya no es válido</Title>
      <Subtitle>
        Ponte en contacto con la tienda para más información
      </Subtitle>
      <UnknowErrorImage src={ErrorImg}></UnknowErrorImage>
      {isApp && device === 'ios' ? (
        <MainLink href="peppermerchants://home">Volver a la tienda</MainLink>
      ) : (
        <MainButton id="unprocessable-return-btn" onClick={handleReturn}>
          Volver a la tienda
        </MainButton>
      )}
    </>
  );
};

export default Unprocessable;
